export default function CustomSpinner() {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center">
        <div>
          <img
            src={'/images/BEDCLogo.png'}
            width={200}
            height={100}
            alt="BEDC logo"
            className="rounded-xl animate-bounce"
          />
        </div>
  
        <span className="sr-only">Loading...</span>
      </div>
    );
  }